import { queryClient } from "@/services/QueryClient";
import BaseStyles from "@/styles/base-styles";
import theme from "@/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { RecoilRoot } from "recoil";

export default function AppProviders({ children }: { children: ReactNode }) {
  return (
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BaseStyles />
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </ThemeProvider>
    </RecoilRoot>
  );
}
